import { StatusToString } from "typings/assignment";

export function statusToString(status) {
   return StatusToString(status)
}
